import reduce from "lodash/reduce";
import mondialRelayLogo from "@Images/logo-mondial-relay.png";
import { CheerzApiShippingOption } from "@Types/api/addresses";
import {
  ShippingMethod,
  ShippingMethodName,
  ShippingMethodVisual,
  ShippingMode,
  ShippingModes,
  ShippingOptions,
} from "@Types/shipping";
import { convertPriceFromApiToContent, convertPriceFromContentToApi } from "./price";

export const convertShippingOptionFromContentToApi = (
  contentOption: ShippingMode
): CheerzApiShippingOption => {
  return {
    available: contentOption.available !== true ? false : true,
    delivery_dates: contentOption.deliveryDates ? contentOption.deliveryDates : null,
    price: contentOption.price ? convertPriceFromContentToApi(contentOption.price) : null,
    selected: contentOption.selected,
  };
};

export const convertShippingOptionFromApiToContent = (
  jsonOption: CheerzApiShippingOption
): ShippingMode => {
  // hack on available because dev and staging set normal delivery to null while available
  return {
    available: jsonOption.available || (jsonOption.available === null && jsonOption.selected),
    deliveryDates: jsonOption.delivery_dates ? jsonOption.delivery_dates : undefined,
    price: jsonOption.price ? convertPriceFromApiToContent(jsonOption.price) : undefined,
    selected: jsonOption.selected,
  };
};

export const getShippingMethods = (shippingOptions: ShippingOptions): ShippingMethod[] => {
  const tertiaryGreen37Color = "#2c9358";
  const shippingMethodsVisual: ShippingMethodVisual = {
    home: {
      priority: 1,
    },
    mondialRelay: {
      logo: mondialRelayLogo,
      priority: 0,
      tag: {
        color: tertiaryGreen37Color,
        labelId: "cheerz_CheckoutShippingStep_tag__mondialRelay",
      },
    },
  };

  const isAvailableShippingMethod = (value: ShippingModes | undefined): boolean =>
    !!value && (value.express.available || value.normal.available) ? true : false;

  return reduce(
    shippingOptions,
    (result: ShippingMethod[], value, key) => {
      if (isAvailableShippingMethod(value)) {
        const selected = !!value
          ? [{ ...value.normal }, { ...value.express }].some((mode) => mode.selected)
          : false;
        const minPrice =
          !!value?.normal.price?.cents && !!value?.express.price?.cents
            ? Math.min(value.express.price.cents, value.normal.price.cents)
            : value?.normal.price?.cents || value?.express.price?.cents;

        result.push({
          descriptionId: `cheerz_CheckoutShippingStep_description__${key}`,
          labelId: `cheerz_CheckoutShippingStep_title__${key}`,
          logo: shippingMethodsVisual[key].logo,
          minPrice,
          name: key as ShippingMethodName,
          priority: shippingMethodsVisual[key].priority,
          selected,
          tag: shippingMethodsVisual[key].tag,
        });
      }
      return result;
    },
    []
  );
};
